export default __webpack_public_path__ + "static/media/NEW ZEALAND.76f42743.png";